export default function Features() {
  return (
    <section id="features" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-magic-fill"></i>
              阅读体验
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              为追更而生的五大阅读能力
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
              从翻页方式到视觉护眼，从定位章节到续读记忆，MGB漫画网在阅读的每一个细节上都下了功夫。
            </p>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 lg:grid-cols-3">
          {/* Featured: double-page */}
          <article className="flex flex-col justify-between overflow-hidden rounded-lg border border-background-200 bg-background-100 p-5 md:p-6 lg:col-span-2">
            <div>
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-book-2-fill text-xl"></i>
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">双页模式 · 像翻实体书</h3>
              <p className="mt-2 max-w-lg text-sm leading-relaxed text-foreground-600">
                左右两页并排铺开，配合键盘与点击翻页，让大屏和平板获得接近纸质书的沉浸翻页体验，画面更开阔，分镜更有冲击力。
              </p>
            </div>
            <div className="mt-5 flex items-end justify-center gap-3 overflow-hidden rounded-md bg-background-50 p-3">
              <img
                src="https://readdy.ai/api/search-image?query=black%20and%20white%20japanese%20manga%20page%20with%20screentone%20shading%2C%20action%20panel%20of%20two%20swordsmen%20clashing%20blades%20with%20speed%20lines%2C%20bold%20ink%20lineart%2C%20explosive%20impact%20sparks%2C%20high%20contrast%2C%20no%20text%20no%20speech%20bubbles&width=800&height=1067&seq=page-blade-03&orientation=portrait"
                alt="双页模式左页漫画示例"
                className="h-40 md:h-52 w-auto rounded-sm object-cover opacity-90"
              />
              <img
                src="https://readdy.ai/api/search-image?query=black%20and%20white%20japanese%20manga%20page%20with%20screentone%20shading%2C%20climax%20panel%20of%20the%20swordsman%20leaping%20high%20in%20the%20air%20for%20a%20powerful%20downward%20strike%2C%20dramatic%20angle%2C%20flowing%20action%20lines%2C%20dark%20screentones%2C%20no%20text%20no%20speech%20bubbles&width=800&height=1067&seq=page-blade-04&orientation=portrait"
                alt="双页模式右页漫画示例"
                className="h-40 md:h-52 w-auto rounded-sm object-cover"
              />
            </div>
          </article>

          {/* Scroll reading */}
          <article className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
            <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-500 text-background-50">
              <i className="ri-align-vertically text-xl"></i>
            </span>
            <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">滚动阅读</h3>
            <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
              手机竖屏纵向连续滑动，图片无缝衔接、预加载流畅不卡顿，滑到哪一页都能无缝接续。
            </p>
          </article>

          {/* Night mode */}
          <article className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
            <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-500 text-background-50">
              <i className="ri-moon-fill text-xl"></i>
            </span>
            <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">夜间模式</h3>
            <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
              一键切换深色护眼底，降低屏幕亮度刺激，夜晚追更也保护眼睛，久看不累。
            </p>
          </article>

          {/* Chapter jump */}
          <article className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
            <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-list-check-3 text-xl"></i>
            </span>
            <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">目录跳转</h3>
            <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
              章节目录快速定位，任意章节一键直达，跳转不卡顿，追更效率翻倍。
            </p>
          </article>

          {/* Progress */}
          <article className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
            <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-500 text-background-50">
              <i className="ri-history-fill text-xl"></i>
            </span>
            <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">进度记忆</h3>
            <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
              自动保存阅读位置，下次打开直接跳到上次读到的地方，登录账号还可多端同步续读。
            </p>
          </article>
        </div>
      </div>
    </section>
  );
}